<template>
  <div class="yxtbiz-group-member">
    <yxt-drawer
      :visible="visible"
      :before-close="beforeClose"
      :show-close="false"
      :wrapperClosable="false"
      :modal="currentPage === 'Main'"
      size="960"
      @open="init"
      :class="{
        'yxtbiz-group-member-drawer--hidden': !show,
        'yxtbiz-group-member-drawer--transparent': currentPage !== 'Main'
      }"
      custom-class="yxtbiz-group-member-drawer"
      direction="rtl"
    >
      <!-- -->
      <Main v-if="!(currentPage !== 'Main' && back)"  v-bind="bindData"></Main>
      <yxt-drawer
        
        :visible="currentPage === 'Quick'"
        :append-to-body="true"
        :show-close="false"
        :wrapperClosable="false"
        size="480"
        custom-class="yxtbiz-group-member-drawer"
        direction="rtl"
      >
        <Quick v-if="currentPage === 'Quick'" v-bind="bindData"></Quick>
      </yxt-drawer>
      <yxt-drawer
        
        :visible="currentPage === 'Group'"
        :append-to-body="true"
        :show-close="false"
        :wrapperClosable="false"
        size="480"
        custom-class="yxtbiz-group-member-drawer"
        direction="rtl"
      >
        <Group v-if="currentPage === 'Group'" v-bind="bindData"></Group>
      </yxt-drawer>
    </yxt-drawer>
  </div>
</template>

<script>
import { Drawer, Message, MessageBox } from 'yxt-pc';
import Main from './components/main/index';
import Quick from './components/quick';
import Group from './components/group';
import { assertFunction, assertNumber, deepClone } from './utils';
import { getGroupNum, getDisOrderMembers, getSplitMembers, getSameMembers } from './services/group';

// function randomString(len) {
//   len = len || 32;
//   var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
//   var maxPos = $chars.length;
//   var pwd = '';
//   for (let i = 0; i < len; i++) {
//     pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
//   }
//   return pwd;
// }
// const data = [];
// for (let i = 0; i < 1000;i++) {
//   data.push({
//     deptName: randomString(8),
//     fullname: randomString(3),
//     leader: 0,
//     positionName: randomString(5),
//     userId: `${i}`,
//     username: randomString(3)
//   });
// }
// return data;
export default {
  name: 'YxtbizGroupMember',
  components: {
    'yxt-drawer': Drawer,
    Quick,
    Main,
    Group
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    page: {
      type: String,
      default: 'Main'
    },
    memberList: {
      type: Array,
      default: []
    },
    groupList: {
      type: Array,
      default: []
    },
    deleteUser: {
      type: Function,
      default: null
    },
    selectedGroupId: {
      type: String,
      default: ''
    },
    selectedIds: {
      type: Array,
      default: []
    },
    maxMember: {
      type: Number,
      default: null
    },
    maxGroup: {
      type: Number,
      default: null
    },
    action: {
      type: Boolean,
      default: true
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      currentPage: 'Quick',
      currentGroupList: [],
      selectedUserIds: {
        value: []
      },
      currentGroupId: '',
      back: true,
      groupLen: 0
    };
  },
  computed: {
    leftMemberNum() {
      let total = this.memberList.length;
      for (let i = 0; i < this.currentGroupList.length;i++) {
        total -= this.currentGroupList[i].groupMemberList.length;
      }
      return total;
    },
    bindData() {
      return {
        'member-list': this.memberList,
        'group-list': this.currentGroupList,
        'group-id': this.currentGroupId,
        'back': this.back,
        'action': this.action,
        'maxMember': this.maxMember,
        'maxGroup': this.maxGroup
      };
    }
  },
  watch: {
    visible() {
      if (!this.visible) {
        this.release();
      }
    },
    currentGroupList() {
      (this.currentGroupList.length === 0) && (this.groupLen = 0);
    }
  },
  provide() {
    return {
      addEmptyGroup: this.addEmptyGroup,
      selectedUserIds: this.selectedUserIds,
      setSelectUser: this.setSelectUser,
      leftMemberNum: this.leftMemberNum,
      setGroupId: this.setGroupId,
      setGroupLeader: this.setGroupLeader,
      cancelGroupLeader: this.cancelGroupLeader,
      handleMoveGroupMember: this.handleMoveGroupMember,
      deleteGroup: this.deleteGroup,
      removeMember: this.removeMember,
      dragMember: this.dragMember,
      deleteUser: this._deleteUser,
      clearGroup: this.clearGroup,
      quickGroup: this.quickGroup,
      setPage: this.setPage,
      close: this.close,
      submit: this.submit,
      addUser: this.addUser,
      selectGroup: this.selectGroup
    };
  },
  methods: {
    init() {
      this.currentPage = this.page;
      this.currentGroupList = deepClone(this.groupList);
      this.selectedGroupId && (this.currentGroupId = this.selectedGroupId);
      this.selectedIds && (this.selectedUserIds.value = deepClone(this.selectedIds));
      this.groupLen = this.currentGroupList.length;
    },
    release() {
      this.currentPage = 'Main';
      this.currentGroupList = [];
      this.currentGroupId = '';
      this.selectedUserIds.value = [];
      this.back = true;
      this.groupLen = 0;
    },
    // 清除分组
    clearGroup() {
      if (this.currentGroupList.length) {
        MessageBox.confirm(this.$t('pc_biz_group_clear_content' /* 重置分组后，所有员工将会恢复到未分组状态 */), this.$t('pc_biz_group_clear_title' /* 确认重置分组 */), {
          confirmButtonText: this.$t('pc_biz_ote_btn_confirm' /* 确认 */),
          cancelButtonText: this.$t('pc_biz_udp_btn_cancel' /* 取消 */),
          type: 'warning'
        }).then(()=>{
          this.currentGroupList = [];
          this.setSelectUser([]);
          this.setGroupId('');
        });
      }
    },

    // 设置选中分组  空表示未分组
    setGroupId(id) {
      this.currentGroupId = id;
    },

    // 返回一个新分组
    getNewGroup() {
      this.groupLen++;
      return {
        edit: true,
        groupMemberList: [],
        groupName: this.$t('pc_biz_group_new_name', [this.groupLen]) /* `第 ${this.groupLen} 组` */,
        id: `new_${this.groupLen}`
      };
    },

    // 移除单个分组人员
    handleMoveGroupMember(userId, groupId) {
      const group = this.currentGroupList.find(group => group.id === groupId);
      if (group) {
        group.groupMemberList = group.groupMemberList.filter(item=>item.userId !== userId);
      }
    },
    // 移除单个分组
    deleteGroup(groupId) {
      const group = this.currentGroupList.find(group => group.id === groupId);
      if (group) {
        // 删除选中人员
        const memberIds = group.groupMemberList.map(item=>item.userId);
        // 重置选择分组
        groupId === this.currentGroupId && this.setGroupId('');
        const newSelectIds = this.selectedUserIds.value.filter(id=>!memberIds.includes(id));
        this.setSelectUser(newSelectIds);

        // 删除分组
        this.currentGroupList = this.currentGroupList.filter(item=>item.id !== groupId);
      }
    },

    // 批量移除人员
    removeMember() {
      this.handleMoveMember();
      Message.success(this.$t('pc_biz_group_remove_tip', [this.selectedUserIds.value.length])/* `已将 ${this.selectedUserIds.value.length} 人移出至“待分组”`*/);
      this.setSelectUser([]);
    },

    // 批量移动分组人员
    handleMoveMember() {
      // 获取已选中
      let moveMemberIds = this.selectedUserIds.value;
      // 过滤
      for (let i = 0; i < this.currentGroupList.length;i++) {
        this.currentGroupList[i].groupMemberList = this.currentGroupList[i].groupMemberList.filter(member=>!moveMemberIds.includes(member.userId));
      }
    },

    // 移动分组
    handleMoveGroup(groupId, moveMemberIds) {
      if (!groupId) {
        return;
      }
      // 获取分组
      let group = {};
      if (groupId === 'new') {

        this._assertGroupNumber();
        group = this.getNewGroup();
        this.currentGroupList.push(group);
      } else {
        group = this.currentGroupList.find(group => group.id === groupId);
      }

      // 删除其他分组中移入人员
      const memberIds = new Set(moveMemberIds);
      for (let i = 0; i < this.currentGroupList.length;i++) {
        if (this.currentGroupList[i].id === groupId) {
          this.currentGroupList[i].groupMemberList.forEach(item=>{
            // 去掉传入分组人员  去重
            memberIds.delete(item.userId);
          });
        } else {
          // 过滤其他分组选中人员
          this.currentGroupList[i].groupMemberList = this.currentGroupList[i].groupMemberList.filter(member=>!moveMemberIds.includes(member.userId));
        }
      }
      moveMemberIds = Array.from(memberIds);
      this._assertGroupMember(group.id, moveMemberIds);
      const moveMembers = [];
      // 查找传入人员
      for (let i = 0;i < this.memberList.length; i++) {
        const item = this.memberList[i];
        if (moveMemberIds.includes(item.userId)) {
          item.leader = 0;
          moveMembers.push(item);
        }
      }
      // 移入人员
      group.groupMemberList = group.groupMemberList.concat(moveMembers);
      return group;
    },
    _assertMaxNumber(num) {
      if (this.maxMember && assertNumber(this.maxMember)) {
        return num > this.maxMember;
      }
      return false;
    },
    _assertGroupNumber() {
      if (this._assertMaxGroup(this.currentGroupList.length)) {
        Message.error(this.$t('pc_biz_group_max_group_tip', [this.maxGroup] /* 组数超出上限：${this.maxGroup} */));
        throw new Error(`maxGroup:${this.maxGroup}`);
      }
    },
    _assertGroupMember(groupId, moveMemberIds) {
      if (this.maxMember && assertNumber(this.maxMember)) {
        let num = moveMemberIds.length;
        if (groupId !== 'new') {
          const group = this.currentGroupList.find(item=>item.id === groupId);
          num += group.groupMemberList.length;
        }
        if (this._assertMaxNumber(num)) {
          Message.error(this.$t('pc_biz_group_max_member_tip', [this.maxMember] /* 人数超出上限：${this.maxMember} */));
          throw new Error(`num:${num} greater than maxMember: ${this.maxMember}`);
        }
      }
    },
    _getMoveMember(userId) {
      if (userId && !this.selectedUserIds.value.includes(userId)) {
        return [userId];
      }
      return this.selectedUserIds.value;
    },
    _moveSingleMember(groupId, userId) {
      // 获取移动人员
      const moveMemberIds = this._getMoveMember(userId);
      // 分组数量检测
      groupId === 'new' && this._assertGroupNumber(groupId);
      // 分组人员数量检测
      this._assertGroupMember(groupId, moveMemberIds);
      // 移动分组
      this.handleMoveGroup(groupId, moveMemberIds);
    },
    _moveSelectedMember(groupId, userId) {
      // 获取移动人员
      const moveMemberIds = this._getMoveMember(userId);
      // 分组数量检测
      groupId === 'new' && this._assertGroupNumber(groupId);
      // 分组人员数量检测
      this._assertGroupMember(groupId, moveMemberIds);
      // 移动分组
      this.handleMoveGroup(groupId, moveMemberIds);

      // 重置选中
      this.setSelectUser([]);
      // 设置界面
      this.setPage('Main');
    },
    _getMoveFn(userId) {
      if (!userId || this.selectedUserIds.value.includes(userId)) {
        return this._moveSelectedMember;
      }
      return this._moveSingleMember;
    },
    // 拖动人员
    dragMember(groupId, userId) {
      this._getMoveFn(userId)(groupId, userId);
      const msg = groupId === 'new' ? this.$t('pc_biz_group_remove_tip_1')/* '成功移动至新建小组' */ : this.$t('pc_biz_group_remove_tip_2') /* '移动成功' */;
      Message.success(msg);
    },
    // 获取剩余人员
    getLeftMember() {
      let groupMemberIds = [];
      for (let i = 0; i < this.currentGroupList.length;i++) {
        groupMemberIds = groupMemberIds.concat(this.currentGroupList[i].groupMemberList.map(item=>item.userId));
      }
      return this.memberList.filter(item=>!groupMemberIds.includes(item.userId));
    },

    // 随机分组
    randomGroupMember(members, memberNum, groupNum) {
      // 乱序
      const disOrderMembers = getDisOrderMembers(members);
      const res = [];
      const groupNumArr = getGroupNum(disOrderMembers.length, memberNum, groupNum);
      groupNumArr.reduce((total, num)=>{
        const start = total;
        const end = total + num;
        const chunk = disOrderMembers.slice(start, end);
        res.push(chunk);
        return end;
      }, 0);
      return res;
    },
    // 部门分开
    splitGroupMember(members, memberNum, groupNum) {
      const res = [];
      // 根据部门切分人员
      let initStart = 0;
      const disOrderMembers = getSplitMembers(members);
      const groupNumArr = getGroupNum(disOrderMembers.length, memberNum, groupNum);
      groupNumArr.reduce((total, num)=>{
        const start = total;
        const end = total + num;
        const chunk = disOrderMembers.slice(start, end);
        res.push(chunk);
        return end;
      }, initStart);
      return res;
    },
    // 部门同组
    sameGroupMember(members, memberNum, groupNum) {
      const res = [];
      // 根据部门组合人员
      let initStart = 0;
      const groupNumArr = getGroupNum(members.length, memberNum, groupNum);
      const disOrderMembers = getSameMembers(members, groupNumArr);
      groupNumArr.reduce((total, num)=>{
        const start = total;
        const end = total + num;
        const chunk = disOrderMembers.slice(start, end);
        res.push(chunk);
        return end;
      }, initStart);
      return res;
    },
    // 计算分组人员
    extractGroupMember(members, groupNum, rule) {
      //  尽量平均分人，需要重新计算每组实际最大人数
      const realMemberNum = Math.ceil(members.length / groupNum);
      // 'random' // same // split
      // 随机分组
      let fn = this.randomGroupMember;
      // 部门分组
      rule === 'split' && (fn = this.splitGroupMember);
      // 部门同组
      rule === 'same' && (fn = this.sameGroupMember);
      const resMembers = fn(members, realMemberNum, groupNum);
      // 校验计算结果
      if (groupNum !== resMembers.length) {
        throw new Error('extractGroupMember failed, not expectation members value');
      }
      return resMembers;
    },
    // 生成分组
    generateGroup(groupNum, groupMember) {
      for (let i = 0;i < groupNum;i++) {
        const group = this.getNewGroup();
        group.edit = false;
        group.groupMemberList = groupMember[i];
        this.currentGroupList.push(group);
      }
    },
    assertQuickParam(groupNumParam, memberNumParam) {
      const groupNum = ~~groupNumParam;
      const memberNum = ~~memberNumParam;
      if (!memberNum || !groupNum) {
        throw new Error('quickGroup failed, not expectation param value');
      }
      if (this._assertMaxNumber(memberNum)) {
        Message.error(this.$t('pc_biz_group_max_tip_1', [this.maxMember]) /* `超出最大人数：${this.maxMember}，分组失败` */);
        throw new Error(`num:${memberNum} greater than maxMember: ${this.maxMember}`);
      }
      return {
        groupNum,
        memberNum
      };
    },

    // 快速分组需要判断剩余人数是否大于分组限制人数
    // 当分组数量限制 和 组内人数限制都存在时 需要检验
    // 计算公式 剩余人数 <= 剩余分组数量 * 最大分组数量
    _assertQuickGroup() {
      if (this.maxGroup && assertNumber(this.maxGroup) && this.maxMember && assertNumber(this.maxMember)) {
        return this.leftMemberNum > (this.maxGroup - this.currentGroupList.length) * this.maxMember;
      }
      return false;
    },
    // 快速分组
    quickGroup(groupNumParam, memberNumParam, rule) {
      // 数据校验
      const { groupNum } = this.assertQuickParam(groupNumParam, memberNumParam);
      // 获取未分组人员
      const leftMember = this.getLeftMember();
      // 计算人员分组结果
      const groupMember = this.extractGroupMember(leftMember, groupNum, rule);
      // 生成分组
      this.generateGroup(groupNum, groupMember);

      // 清除操作数据
      this.setGroupId('');
      this.setSelectUser([]);
      // 进入分组编辑页面;
      this.setPage('Main');
    },
    // 设置组长
    setGroupLeader(userId, groupId) {
      const group = this.currentGroupList.find(group => group.id === groupId);
      if (group) {
        group.groupMemberList.forEach(member => {
          if (member.userId === userId) {
            member.leader = 1;
          } else {
            member.leader = 0;
          }
        });
      }
    },

    // 取消组长
    cancelGroupLeader(userId, groupId) {
      const group = this.currentGroupList.find(group => group.id === groupId);
      if (group) {
        const member = group.groupMemberList.find(item=>item.leader && item.userId === userId);
        member.leader = 0;
      }
    },

    // 检测分组数量
    _assertMaxGroup(num) {
      if (this.maxGroup && assertNumber(this.maxGroup)) {
        return num >= this.maxGroup;
      }
      return false;
    },
    // 创建空分组
    addEmptyGroup() {
      this._assertGroupNumber();
      const newGroup = this.getNewGroup();
      this.currentGroupList.push(newGroup);
    },
    getSelectUser() {
      return this.selectedUserIds;
    },
    setPage(page) {
      if (page === 'Quick' && this.maxGroup) {
        if (this.maxMember && this._assertQuickGroup()) {
          Message.error(this.$t('pc_biz_group_max_rule_tip', [this.maxMember, this.maxGroup]) /* `每组最多 ${this.maxMember} 人，最多 ${this.maxGroup} 组` */);
          throw new Error(`left member:${this.leftMemberNum} greater than maxMember: ${this.maxMember * this.maxGroup}`);
        } else {
          this._assertGroupNumber();
        }
      }
      this.currentPage = page;
      this.back = false;
    },
    // 设置选中人员
    setSelectUser(userIds) {
      this.selectedUserIds.value = Array.from(new Set(userIds));
    },
    // 删除选中人员
    async _deleteUser(userIds) {
      if (this.$props.deleteUser && assertFunction(this.$props.deleteUser)) {
        const users = this.memberList.filter(item=>userIds.includes(item.userId));
        // 执行删除方法
        const res = await this.$props.deleteUser(users);
        if (res) {
          // 删除成功
          for (let i = 0; i < this.currentGroupList.length;i++) {
            // 过滤已分组人员
            this.currentGroupList[i].groupMemberList = this.currentGroupList[i].groupMemberList.filter(member=>!userIds.includes(member.userId));
          }
          // 过滤人员
          this.memberList = this.memberList.filter(member=>!userIds.includes(member.userId));
          // 清除操作记录
          this.setSelectUser(this.selectedUserIds.value.filter(id=>!userIds.includes(id)));

          Message.success(this.$t('pc_biz_group_remove_tip_3', [userIds.length]) /* `已删除 ${userIds.length} 人` */);
        }
      } else {
        throw new Error('Please provide deleteUser function');
      }
    },
    beforeClose() {
      this.$emit('beforeClose');
    },
    close() {
      MessageBox.confirm(this.$t('pc_biz_group_cancel_content') /* 确认取消本次编辑？取消后您编辑的内容将不会保存 */, this.$t('pc_biz_group_cancel_title')/* '确认取消' */, {
        confirmButtonText: this.$t('pc_biz_ote_btn_confirm' /* 确认 */),
        cancelButtonText: this.$t('pc_biz_udp_btn_cancel' /* 取消 */),
        type: 'warning'
      }).then(()=>{
        this.$emit('close');
      });
    },
    addUser() {
      this.$emit('addNotify');
    },
    selectGroup(id) {
      this.$emit('selectGroup', id);
    },
    submit() {
      const list = [];
      for (let i = 0; i < this.currentGroupList.length;i++) {
        const item = this.currentGroupList[i];
        if (!item.groupMemberList.length) {
          continue;
        }
        const groupMemberList = item.groupMemberList.map(item=>{
          return {
            leader: ~~item.leader,
            userId: item.userId
          };
        });
        let groupId = item.id;
        if (item.id.startsWith('new_')) {
          groupId = '';
        }
        list.push({
          groupId,
          groupMemberList,
          groupName: item.groupName
        });
      }
      // if (!list.length) {
      //   Message.error(this.$t('pc_biz_group_commit_tip_1' /* 请先对人员进行分组 */));
      //   return;
      // }
      this.$emit('submit', list);
    },
    getDrawerSize() {
      if (this.currentPage === 'Quick') {
        return '480';
      }
      return '960';
    }
  }
};
</script>
<style lang="scss">
.yxtbiz-group-member-drawer{
  .yxt-drawer__body{
    padding: 0;
    // width: 480px;
    // transition: width .2s ease-in-out;
  }
  * {
        box-sizing: border-box;
  }
}
.yxtbiz-group-member-drawer--hidden{
  display: none;
}
// .yxtbiz-group-member-drawer-Main{
//   .yxt-drawer__body{
//     width: 960px;
//   }
// }
.yxtbiz-group-member-drawer--transparent{
  pointer-events:none;

  .yxt-drawer__container{
    pointer-events:none;
  }
}
</style>

<style lang="scss" scoped>
// .slide-fade-enter-active {
//   transition: all .2s ease-out;
// }
// .slide-fade-leave-active {
//   transition: all .2s ease-out;
// }
// .slide-fade-enter, .slide-fade-leave-to{
//   transform: translateX(100px);
//   opacity: 0;
// }
</style>
